import { navigate } from 'gatsby';
import { returnLocalisedPath } from 'globalUtils';
import { withLocale } from '../../utils/hocs';

export const PrivateRoute = withLocale(({ children, isPrivate, locale }) => {
  if (
    isPrivate &&
    typeof window !== 'undefined' &&
    !window.localStorage.userToken
  ) {
    navigate(returnLocalisedPath(locale[0], 'login'));
    return null;
  } else {
    return children;
  }
});
